import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { BreadcrumbProvider } from "../lib/BreadcrumbContext";

export function AppLayout() {
  return (
    <BreadcrumbProvider>
      <div className="app-layout">
        <Sidebar />
        <div className="app-main">
          <Topbar />
          <div className="app-content">
            <Outlet />
          </div>
        </div>
      </div>
    </BreadcrumbProvider>
  );
}
